// src/models/Unit.js

export class Unit {
    constructor(unitKey, team, x, y) {
      // Basic properties
      this.unitKey = unitKey;
      this.team = team;
      this.x = x;
      this.y = y;
      
      // Placeholder values - to be overridden by unit type data
      this.name = unitKey;
      this.health = 100;
      this.maxHealth = 100;
      this.damage = 10;
      this.defense = 0;
      this.range = 30;
      this.speed = 1.5;
      this.type = 'generic';
      this.emoji = '👤';
      this.size = 24;
      
      // Combat state
      this.target = null;
      this.lastAttackTime = 0;
      this.attackCooldown = 1000;
      this.state = 'idle'; // 'idle', 'moving', 'attacking'
      
      // For grid placement
      this.gridPosition = null;
    }
    
    // Check if unit contains a point (for selection)
    containsPoint(x, y) {
      return Math.hypot(this.x - x, this.y - y) <= this.size;
    }
    
    // Find the nearest enemy
    findNearestEnemy(enemies) {
      if (!enemies || enemies.length === 0) return null;
      
      let nearest = null;
      let minDistance = Infinity;
      
      for (const enemy of enemies) {
        const distance = Math.hypot(enemy.x - this.x, enemy.y - this.y);
        if (distance < minDistance) {
          minDistance = distance;
          nearest = enemy;
        }
      }
      
      return nearest;
    }
    
    // Move toward target
    moveTowardTarget() {
      if (!this.target || this.isStructure) return;
      
      const dx = this.target.x - this.x;
      const dy = this.target.y - this.y;
      const distance = Math.hypot(dx, dy);
      
      // Only move if not in attack range
      if (distance > this.range) {
        this.state = 'moving';
        
        const vx = (dx / distance) * this.speed;
        const vy = (dy / distance) * this.speed;
        
        this.x += vx;
        this.y += vy;
      } else {
        this.state = 'idle';
      }
    }
    
    // Attack target
    attack(currentTime) {
      if (!this.target || this.target.health <= 0) return false;
      
      const distance = Math.hypot(this.target.x - this.x, this.target.y - this.y);
      
      if (distance <= this.range && currentTime - this.lastAttackTime > this.attackCooldown) {
        this.state = 'attacking';
        
        // Calculate damage
        const damage = Math.max(1, this.damage - this.target.defense);
        this.target.health -= damage;
        
        this.lastAttackTime = currentTime;
        return true;
      }
      
      return false;
    }
  }